var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styled from 'styled-components';
import { Svg } from './Svg';
var FileTextIcon = function (props) { return (React.createElement(Svg, __assign({}, props),
    React.createElement("g", null,
        React.createElement("path", { d: "M16 14V12H8V14H16Z" }),
        React.createElement("path", { d: "M16 18V16H8V18H16Z" }),
        React.createElement("path", { d: "M10 8H8V10H10V8Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.707 8.293C19.793 8.379 19.854 8.48 19.903 8.586C19.9154 8.61255 19.9239 8.63989 19.9326 8.668C19.9337 8.67166 19.9349 8.67532 19.936 8.679C19.965 8.763 19.982 8.849 19.987 8.938C19.9879 8.94813 19.9907 8.95762 19.9935 8.96697C19.9968 8.97792 20 8.98867 20 9V20C20 21.103 19.103 22 18 22H6C4.897 22 4 21.103 4 20V4C4 2.897 4.897 2 6 2H13C13.0115 2 13.0224 2.00329 13.0333 2.0066C13.0424 2.00934 13.0515 2.01209 13.061 2.013C13.15 2.018 13.236 2.036 13.32 2.064C13.33 2.06743 13.3399 2.07056 13.3498 2.07368C13.3717 2.08057 13.3933 2.08736 13.414 2.097C13.52 2.146 13.621 2.207 13.707 2.293L19.707 8.293ZM14 8H16.586L14 5.414V8ZM6 4V20H18.002L18 10H13C12.447 10 12 9.553 12 9V4H6Z" })))); };
export var FileText = styled(FileTextIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
//# sourceMappingURL=FileText.js.map